/**
 * Public Layout
 *
 * Header layout for public-facing pages
 */

import { Link, Outlet } from "react-router-dom";

export function PublicLayout() {
  return (
    <>
      {/* Header */}
      <header className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-full bg-[var(--ink)] text-white flex items-center justify-center font-semibold">
            B
          </div>
          <div>
            <p className="font-semibold text-lg">Boat361</p>
            <p className="text-xs text-slate-500">Vessels Marketplace</p>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-6 text-sm font-semibold text-slate-700">
          <Link to="/search">Marketplace</Link>
          <Link to="/dashboard">Dashboard</Link>
          <Link to="/dashboard/messages">Inbox</Link>
        </nav>
        <div className="flex items-center gap-3">
          <Link
            className="px-5 py-2 rounded-full bg-[var(--ink)] text-white font-semibold"
            to="/search"
          >
            Search boats
          </Link>
          <Link className="text-sm font-semibold text-[var(--accent)]" to="/dashboard">
            Launch app
          </Link>
        </div>
      </header>

      {/* Page Content */}
      <Outlet />
    </>
  );
}
